$(function () {
    (function initHeroRotation() {
        var heroEl = document.querySelector(".hero[data-hero-rotation]");
        if (!heroEl) {
            return;
        }

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return;
        }

        var raw = heroEl.getAttribute("data-hero-rotation");
        if (!raw) {
            return;
        }

        var urls;
        try {
            urls = JSON.parse(raw);
        } catch (err) {
            return;
        }
        if (!urls || urls.length < 1) {
            return;
        }

        var multiImage = urls.length > 1;

        var layers = heroEl.querySelectorAll(".hero-bg");
        if (layers.length < 2) {
            return;
        }

        var bgA = layers[0];
        var bgB = layers[1];

        var $hero = $(heroEl);
        var idx = 0;
        var panClass = "hero--pan-cycle";
        var desktopIntervalMs = 10000;
        var desktopMq = window.matchMedia("(min-width: 576px)");
        var intervalId = null;
        var fadeEndHandler = null;

        heroEl.classList.add("hero--has-bg-layers");
        heroEl.style.removeProperty("--hero-bg-image");

        function urlCss(u) {
            var escaped = u.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
            return 'url("' + escaped + '")';
        }

        function setBgElement(el, i) {
            el.style.setProperty("background-image", urlCss(urls[i]));
        }

        function syncLayersToIndex() {
            setBgElement(bgA, idx);
            setBgElement(bgB, idx);
            bgA.classList.add("is-visible");
            bgB.classList.remove("is-visible");
        }

        function getFrontBack() {
            if (bgA.classList.contains("is-visible")) {
                return { front: bgA, back: bgB };
            }
            return { front: bgB, back: bgA };
        }

        function advanceWithCrossfade(done) {
            if (fadeEndHandler) {
                heroEl.removeEventListener("transitionend", fadeEndHandler);
                fadeEndHandler = null;
            }

            idx = (idx + 1) % urls.length;
            var pair = getFrontBack();
            setBgElement(pair.back, idx);
            pair.back.style.backgroundPosition = "0% center";

            void heroEl.offsetWidth;

            var fadeDone = false;
            fadeEndHandler = function onFadeEnd(e) {
                if (!e.target.classList || !e.target.classList.contains("hero-bg")) {
                    return;
                }
                if (e.propertyName !== "opacity") {
                    return;
                }
                if (fadeDone) {
                    return;
                }
                fadeDone = true;
                heroEl.removeEventListener("transitionend", fadeEndHandler);
                fadeEndHandler = null;
                if (done) {
                    done();
                }
            };

            heroEl.addEventListener("transitionend", fadeEndHandler);
            pair.front.classList.remove("is-visible");
            pair.back.classList.add("is-visible");
        }

        function stopDesktopRotation() {
            if (intervalId !== null) {
                clearInterval(intervalId);
                intervalId = null;
            }
        }

        function startDesktopRotation() {
            stopDesktopRotation();
            intervalId = window.setInterval(function () {
                advanceWithCrossfade(null);
            }, desktopIntervalMs);
        }

        function stopMobilePan() {
            $hero.off("animationend.heroPan");
            $hero.removeClass(panClass);
        }

        function startMobilePan() {
            stopMobilePan();
            $hero.on("animationend.heroPan", function (e) {
                var t = e.target;
                if (!t.classList.contains("hero-bg") || !t.classList.contains("is-visible")) {
                    return;
                }
                var oe = e.originalEvent;
                var animName = oe && (oe.animationName || "");
                if (animName !== "hero-bg-pan") {
                    return;
                }
                $hero.removeClass(panClass);
                advanceWithCrossfade(function () {
                    void heroEl.offsetWidth;
                    $hero.addClass(panClass);
                });
            });
            $hero.addClass(panClass);
        }

        function applyHeroLayoutMode() {
            if (fadeEndHandler) {
                heroEl.removeEventListener("transitionend", fadeEndHandler);
                fadeEndHandler = null;
            }
            if (!multiImage) {
                stopDesktopRotation();
                stopMobilePan();
                syncLayersToIndex();
                return;
            }
            if (desktopMq.matches) {
                stopMobilePan();
                syncLayersToIndex();
                startDesktopRotation();
            } else {
                stopDesktopRotation();
                stopMobilePan();
                syncLayersToIndex();
                startMobilePan();
            }
        }

        setBgElement(bgA, 0);
        setBgElement(bgB, 0);
        bgA.classList.add("is-visible");
        bgB.classList.remove("is-visible");
        idx = 0;
        applyHeroLayoutMode();

        if (typeof desktopMq.addEventListener === "function") {
            desktopMq.addEventListener("change", applyHeroLayoutMode);
        } else if (typeof desktopMq.addListener === "function") {
            desktopMq.addListener(applyHeroLayoutMode);
        }
    })();
});
